<template>
  <div>
    <div class="security_container__class">
      <div class="security_title__class py-2" v-if="security.symbol">
        {{ security.symbol }}
      </div>
      <div class="d-flex">
        <div class="price_key__class mb-2">
          Previous Price
          <span class="price__class" v-if="security.close_price">
            ₹{{ security.close_price.toFixed(2) }}</span
          ><span v-else>-</span>
        </div>
        <v-spacer></v-spacer>
        <div class="price_key__class">
          Current Price
          <span class="price__class" v-if="security.live_price"
            >₹{{ security.live_price.toFixed(2) }}</span
          ><span v-else>-</span>
        </div>
      </div>
      <v-divider></v-divider>
      <div class="d-flex mt-1">
        <div class="price_key__class">Growth after news released</div>
        <v-spacer></v-spacer>
        <div class="growth__class">
          <div v-if="growth">
            <span>
              <v-icon small color="#27ae60" v-if="growth >= 0">mdi-arrow-up</v-icon>
              <v-icon small color="#eb5757" v-else>mdi-arrow-down</v-icon> </span
            ><span :class="growth >= 0 ? 'positive__class' : 'negative__class'"
              >{{ growth }}%</span
            >
          </div>
          <div v-else>-</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SecurityCard",
  props: {
    security: {
      type: Object,
    },
    growth: {
      default: null,
      type: Number,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {},
};
</script>
<style scoped>
.security_container__class {
  background: #f2f8ff;
  border-radius: 6px;
  min-height: 96px;
  padding: 10px;
}
.security_title__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 23px;
  /* identical to box height, or 144% */

  color: #333333;
}
.price_key__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  /* identical to box height */

  color: #7b7b7b;
}
.price__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;

  color: #333333;
}
.growth__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 17px;
  line-height: 23px;

  /* Green 2 */
}
.positive__class {
  color: #27ae60;
}
.negative__class {
  color: #eb5757;
}
@media only screen and (min-width: 600px) {
  .price_key__class {
    font-weight: 400;
    font-size: 12px;
    line-height: 16.39px;
  }
  .price__class {
    font-weight: 500;
    font-size: 14px;
    line-height: 19.12px;
  }
  .security_title__class {
    font-weight: 900;
    font-size: 14px;
    line-height: 23px;
  }
  .growth__class {
    font-weight: 900;
    font-size: 16px;
    line-height: 21.86px;

    /* Green 2 */
  }
}
</style>
